import { render, staticRenderFns } from "./partnerMovement.vue?vue&type=template&id=d12ec128&"
import script from "./partnerMovement.vue?vue&type=script&lang=js&"
export * from "./partnerMovement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports